import { usePartyNames } from "../../hooks/usePartyNames";

/** A party's Directory name, inline (never the raw ID). */
const PartyName = ({ partyId, fallback = "—" }) => {
  const names = usePartyNames(partyId ? [partyId] : []);
  if (!partyId) return fallback;
  return names[partyId] || "Loading…";
};

export default PartyName;
